function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M24 0a24 24 0 110 48 24 24 0 010-48zm0 4.64A19.34 19.34 0 006.97 33.22a10.89 10.89 0 016.52-5.47 12.45 12.45 0 01-2.02-6.84 12.53 12.53 0 1123.04 6.84 10.89 10.89 0 016.52 5.47A19.28 19.28 0 0043.35 24C43.35 13.3 34.7 4.64 24 4.64z",
  fillRule: "evenodd"
})));